@if (loading) {
  <div class="d-flex justify-content-center align-items-center h-100">
    <ix-spinner></ix-spinner>
  </div>
} @else if (isHandoverDocumentation) {
  <app-handover-documentation [passportName]="passportName"></app-handover-documentation>
} @else {
  <app-generic-submodel-viewer></app-generic-submodel-viewer>
}
